<template>
  <div id="coaching-app">
    <CoachingComponent/>
  </div>
</template>

<script>
import CoachingComponent from './components/CoachingComponent.vue'

export default {
  name: 'app',
  components: {
    CoachingComponent
  }
}
</script>

<style>
/* import if running locally*/
/*@import url(http://iihf.devweb13.emakina.at/App_Themes/Emakina/styles/app.css);*/
</style>
